import axios from 'axios';
import { clearToken, getToken, isTokenExpired } from '@/utils/auth';
import router from '@/router';
import { startGlobalLoading, stopGlobalLoading } from '@/utils/loading';

const http = axios.create({
  baseURL: '/',
  timeout: 40000
});

http.interceptors.request.use((config) => {
  startGlobalLoading();
  const token = getToken();
  if (token) {
    if (isTokenExpired(token)) {
      stopGlobalLoading();
      clearToken();
      if (router.currentRoute.value.path !== '/login') {
        router.push('/login');
      }
      return Promise.reject(new Error('登录状态已失效，请重新登录'));
    }
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  stopGlobalLoading();
  return Promise.reject(error);
});

http.interceptors.response.use(
  (response) => {
    stopGlobalLoading();
    const body = response.data;
    if (body && body.success === false) {
      return Promise.reject(new Error(body.message || '请求失败'));
    }
    return body;
  },
  (error) => {
    stopGlobalLoading();
    if (error.response && error.response.status === 401) {
      clearToken();
      if (router.currentRoute.value.path !== '/login') {
        router.push('/login');
      }
    }
    return Promise.reject(error);
  }
);

export default http;
